export default import.meta.ROLLUP_FILE_URL__IyPT_e74KgNQxdN7PcfdQ